import { DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, signal } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableModule } from '@angular/material/table';
import { DataTableContainerComponent } from '../../components/data-table-container/data-table-container.component';

@Component({
  selector: 'app-robot-sessions',
  imports: [MatTableModule, MatPaginator, DatePipe, DataTableContainerComponent],
  templateUrl: './robot-sessions.component.html',
  styleUrl: './robot-sessions.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RobotSessionsComponent {
  protected readonly dataSource = signal([
    {
      startedAt: new Date(Date.now() - 1000 * 60 * 60),
      endedAt: new Date(),
      duration: '01:00:00',
    },
  ]);

  protected readonly displayedColumns = ['startedAt', 'endedAt', 'duration'];
}
